import {AppService} from '@shared/services/app.service';
import {ReserveRepository} from '@app/@core/repositories/reserve.repository';
import {forkJoin} from 'rxjs';
import {SelectItem} from 'primeng/api';
import {BaseSearch} from '@shared/helper/search/base-search';

export class BookingSearch extends BaseSearch {
    constructor(
        private appService: AppService,
        private reserveRepository: ReserveRepository,
        private callback: (value: string) => void
    ) {
        super();
    }

    onSearch(): void {
        forkJoin([
            this.reserveRepository.searchTransaction({gdInvoiceId: this.term.trim()}),
            this.reserveRepository.searchTransaction({code: this.term.trim()})
        ]).subscribe(([a, b]) => {
            const list: SelectItem[] = [
                ...a.map((r) => ({value: r.id, label: r.gdInvoiceId})),
                ...b.map((r) => ({value: r.id, label: r.code}))
            ];

            this.filteredModel = list;
            if (list.length === 0) {
                this.appService.toastAlert('Not found');
            }
        });
    }

    onSelected(value): void {
        this.callback(value);
    }
}
